import * as React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Slug } from '@fnv-core/utils';
import { FileNameHelpers } from '../helpers/FileNameHelpers';
import { FormControlHelpers } from '../formcontrols/helpers/FormControlHelpers';
import { DatasourceOptionsService } from '../services/DatasourceOptionsService';

export interface SummaryProps {
  formFieldDefinition?: any; 
  onClick?: any;
  formDefinitions?: any;
  forms: any;
  formContainer?: any;
}

/**
 * Template component for displaying a summary for a single field.
 */
export const Summary = (props: SummaryProps) => {
  return <React.Fragment key={"renderCustomField-summary-" + props.formFieldDefinition.name}>            
  <div className="row no-gutters"> 
    {props.formFieldDefinition.label !== undefined && 
      props.formFieldDefinition.label !== "" ?                  
    <div className="col">
        <h2>{ReactHtmlParser(props.formFieldDefinition.label)}</h2>
    </div> : null }
    
  </div>
  <div className="form-summary__content">
    {props.formFieldDefinition.data.map((item : any, indexFieldDef : number) => {
      let lastFieldEmpty : boolean = false;
      let labelPrinted : boolean = false;
      return <React.Fragment key={"summary__react-fragment__" + indexFieldDef}>
        <div key={"summary__content" + indexFieldDef} className="form-summary__content-label-field-container">
          
          {item.fields.map((field : any , indexItem : number) => {

            if (!!field.hideWhenNoOptions) {
              if (DatasourceOptionsService.getOptionsForForm(field.name).length == 0) {
                return <React.Fragment key={"rf_sc_field" + indexFieldDef + "_" + indexItem} ></React.Fragment>;
              }
            }
            
            let labelHelper = null;
            if (!labelPrinted) {
              labelHelper = <div className={"form-summary__content-label form-summary__content-label-" + Slug.fromString(field)}>{ReactHtmlParser(item.label)}</div>;
              labelPrinted = true;
            }
            
            if (field.indexOf("text:") == 0) {
              return <React.Fragment key={"rf_sc_field" + indexFieldDef + "_" + indexItem} >
                {labelHelper}
                <span key={"sc_field" + indexFieldDef + "_" + indexItem} className="form-summary__content-text">{field.substr(5)}</span>
              </React.Fragment>;
            } else
            if (field == " ") {
              if (lastFieldEmpty) {
                return <React.Fragment key={"sc_field" + indexFieldDef + "_" + indexItem}>{labelHelper}</React.Fragment>;
              } else {
                lastFieldEmpty = false;
                return <React.Fragment key={"rf_sc_field" + indexFieldDef + "_" + indexItem}>
                  {labelHelper}
                  <span key={"sc_field" + indexFieldDef + "_" + indexItem} className="form-summary__content-space">&nbsp;</span>
                </React.Fragment>;
              }
            } else
            if (field == "[ENTER]") {
              lastFieldEmpty = false;
              return <React.Fragment key={"rf_enter_field" + indexFieldDef + "_" + indexItem}>
                  {labelHelper}
                  <div  key={"enter_field" + indexFieldDef + "_" + indexItem} className="form-summary__content-enter"></div>
                </React.Fragment>;
            } else {
              const formFields: string[] = field.split(".");
              if (formFields.length == 2) {
                const formName = formFields[0];
                const fieldName = formFields[1];

                if (props.forms[formName] !== undefined && props.forms[formName][fieldName] !== undefined) {
                  
                  lastFieldEmpty = false;

                  if (item.fieldValueHasLabel === true) {
                    let text = props.forms[formFields[0]][formFields[1]].label;
                    if (typeof item.toUpperCase !== undefined && item.toUpperCase === true) {
                      text = text.toUpperCase();
                    }
                    
                    return <React.Fragment  key={"rf_sc_field" + indexFieldDef + "_" + indexItem}>
                      {labelHelper}
                      <span key={"sc_field" + indexFieldDef + "_" + indexItem} className="form-summary__content-field">{text}</span>
                    </React.Fragment>;

                  } else
                  if (item.viaOption === true) {
                    let valueViaOption = "";

                    props.formDefinitions[formName].map((formDef : any) => {
                      if (formDef.name == fieldName) {

                        if (typeof formDef.datasource === "undefined" && formDef.valueoptions !== undefined) {

                          // conveniance
                          let rawValueFromForm = props.forms[formName][fieldName];
                          let value = rawValueFromForm.toString();
                          if (rawValueFromForm.value) {
                            value = rawValueFromForm.value.toString();
                          }
                          let index = formDef.valueoptions.indexOf(value);
                          if (index >= 0) {
                            valueViaOption = formDef.options[index];
                          }

                        }
                      }
                    });

                    if (typeof item.toUpperCase !== undefined && item.toUpperCase === true) {
                      valueViaOption = valueViaOption.toUpperCase();
                    }

                    if (valueViaOption == "") {
                      valueViaOption = "-";
                    }

                    return <React.Fragment key={"rf_sc_field" + indexFieldDef + "_" + indexItem}>
                        {labelHelper}
                        <span key={"sc_field" + indexFieldDef + "_" + indexItem} className="form-summary__content-field">{valueViaOption}</span>
                      </React.Fragment>;
                  }

                  let isReactComponent = false;
                  let value = props.forms[formName][fieldName];
                  let displayValue = value;
                  
                  // workaround to prevent "true" or "false" being visible in form-summary
                  // (happens with checkboxes)
                  if ((value as unknown || '').toString().toLowerCase() === "true") {
                    displayValue = "Ja";
                  }
              
                  if ((value as unknown || '').toString().toLowerCase() === "false") {
                    // see explicit field type check below
                    displayValue = "Nee";
                  }

                  if (props.formFieldDefinition && props.formFieldDefinition.orgField &&
                    props.formFieldDefinition.orgField.type == "chooseLocation") {
                    const locationNameField = props.formFieldDefinition.orgField.locationNameInPayloadField;  
                    const payload = props.formContainer.getPayload();
                    
                    displayValue = (payload && payload[locationNameField]) || displayValue;
                  }

                  let alwaysShowSummaryFieldOverride : boolean = false;
                  props.formDefinitions[formName].map((formDef : any) => {
                    if (formDef.name == fieldName) {
                      displayValue = FormControlHelpers.convertValueToType(displayValue, formDef);

                      if (formDef.alwaysShowSummaryField === true) {
                        alwaysShowSummaryFieldOverride = true;
                      }

                      if (formDef.type == "fileupload") {
                        labelHelper = null;
                        if (displayValue && displayValue.name) {
                          displayValue = getFileComponent(displayValue.name);
                          isReactComponent = true;
                        }
                      } else 
                      if (formDef.type == "checkbox" || formDef.type == "switch") {
                        // fallback if text is empty and it is a checkbox or switch
                        if (displayValue == "" || !displayValue) {
                          displayValue = "Nee";
                        }
                      }
                    }
                  });
                  
                  if (displayValue && displayValue.label !== undefined) {
                    displayValue = displayValue.label;

                    if (displayValue == "") {
                      lastFieldEmpty = true;
                    }
                  }

                  if (typeof item.toUpperCase !== undefined && item.toUpperCase === true) {                                      
                    displayValue = (displayValue || "").toUpperCase();
                  }

                  if ((displayValue == "" || displayValue == undefined) && 
                      (alwaysShowSummaryFieldOverride ||
                      (props.formFieldDefinition.alwaysShowSummaryField !== undefined && props.formFieldDefinition.alwaysShowSummaryField))
                      ) {
                        displayValue = "-";
                  }

                  return (displayValue != "" ? <React.Fragment key={"rf_sc_field" + indexFieldDef + "_" + indexItem}>
                    {labelHelper}
                    <span key={"sc_field" + indexFieldDef + "_" + indexItem} className="form-summary__content-field">{isReactComponent ? displayValue : 
                      ReactHtmlParser(FormControlHelpers.replaceTaggedEmailAddressesWithoutTags(displayValue))}</span>
                  </React.Fragment> : null);
                }
                
              }
              lastFieldEmpty = true;
              return <React.Fragment  key={"rf_field" + indexFieldDef + "_" + indexItem}></React.Fragment>;
            }
          })}
        </div>
      </React.Fragment>;
    })}
  </div>
</React.Fragment>;
};

function getFileComponent(fileName) {
  if (!fileName) {
    return null;
  }

  const fileNameExtensionImage = FileNameHelpers.getFileAttachmentImage(fileName);
  const fileNameExtension = FileNameHelpers.getFileNameExtensionUppercase(fileName);

  if (fileNameExtensionImage != "") {
    return <span className="filename-ext-icon__wrapper">
      <span className="filename-ext-icon">
        <span className="filename-ext-icon__text">{fileNameExtension}</span>
        <img className="filename-ext-icon__image" src={fileNameExtensionImage} />
      </span>
      <span>{FileNameHelpers.getFileNameWithoutPath(fileName)}</span>
    </span>;
  } else if (fileNameExtension && fileNameExtension !== "") {
    return <span className="filename-ext-icon__wrapper">
      <span className="filename-ext-icon">
        <span className="filename-ext-icon__text">{fileNameExtension}</span>
        <img className="filename-ext-icon__image" src="/assets/img/layout/bekijkook/bekijkook-grijs.svg" />
      </span>
      <span>{FileNameHelpers.getFileNameWithoutPath(fileName)}</span>
    </span>;
  }
}